import { render, staticRenderFns } from "./annualExamResult.vue?vue&type=template&id=25f6b800&scoped=true"
import script from "./annualExamResult.vue?vue&type=script&lang=js"
export * from "./annualExamResult.vue?vue&type=script&lang=js"
import style0 from "./annualExamResult.vue?vue&type=style&index=0&id=25f6b800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f6b800",
  null
  
)

export default component.exports